import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PortalBuilderService } from 'src/app/shared/services/administratior-service/portal-builder.service';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-profile-naming-convention',
  templateUrl: './customer-profile-naming-convention.component.html',
})
export class CustomerProfileNamingConventionComponent
  implements OnInit, OnDestroy
{
  bankName = true;
  customerBankDetailsForm!: FormGroup;
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  currencyData: any = [];
  selectedCurrency: any;
  singleRole: any;
  loginRole: any;
  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private portalBuilderServices: PortalBuilderService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getCurrency();
    this.loginRole = this.userService.getUserRole();
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log("p",res);
        this.singleRole=res?.role?.type
        this.patchCustomerBankDetailsData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        let formatData = this.customerBankDetailsForm.value;
        let payload : any = {};
        payload.bankName = formatData.bankName;
        payload.ifscCode =  formatData.ifscCode;
        payload.accountHolderName =  formatData.accountHolderName;
        payload.branchName = formatData.branchName
        payload.bankPancard = formatData.bankPancard;
        payload.accountNo = formatData.accountNo;
        payload.bankCurrency = this.selectedCurrency ? this.selectedCurrency : res?.bankConfig?.bankCurrency;
        console.log(payload)
        if (this.customerBankDetailsForm.valid) {
          payload.validcustomerBankDetailsForm = true;
          this.customerService.sendCustomerFormData(payload);
          console.log('called');
        } else {
          payload.validcustomerBankDetailsForm = false;
          this.customerService.sendCustomerFormData(payload);
          this.customerBankDetailsForm.markAllAsTouched();
          console.log('called2');
        }
      });
  }

  initForm() {
    this.customerBankDetailsForm = this.formBuilder.group({
      bankName: ['',Validators.required],
      ifscCode: ['', Validators.required],
      accountHolderName: ['', Validators.required],
      bankCurrency: ['', Validators.required],
      branchName: ['', Validators.required],
      bankPancard: ['', [Validators.required,Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')]],
      accountNo: ['', [Validators.required,Validators.pattern('[0-9]{9,18}')]],
    });
  }

  patchCustomerBankDetailsData(data: any) {
    this.customerBankDetailsForm.patchValue({
      bankName: data?.bankConfig?.bankName ?? '',
      ifscCode: data?.bankConfig?.ifscCode,
      accountHolderName: data?.bankConfig?.accountHolderName,
      bankCurrency: data?.bankConfig?.bankCurrency?.currencyId ? data?.bankConfig?.bankCurrency?.currencyId : '',
      branchName: data?.bankConfig?.branchName,
      bankPancard: data?.bankConfig?.pancard,
      accountNo: data?.bankConfig?.accountNo,
    });
    console.log(this.customerBankDetailsForm)
  }

  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
  }
  getCurrency() {
    this.portalBuilderServices.GetCurrency().subscribe({
      next: (response) => {
        this.currencyData = response.data.data;
        console.log('currency res ', this.currencyData);
      },
      error: (error) => {
        console.error('Error  currency state:', error);
      },
      complete: () => {
        console.log('upload currency completed');
        // clean-up logic for this
      },
    });
  }

  onCurrencySelect(ev: any) {
    this.selectedCurrency = this.currencyData.find(
      (item: any) => item?._id == ev.target.value
    );
    console.log(this.selectedCurrency)
  }

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
